import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ src, alt, style }) => (
    <img
        src={src}
        alt={alt}
        style={style}
    />
);

Icon.propTypes = {
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    style: PropTypes.shape(),
};
Icon.defaultProps = {
    style: {},
};

export default Icon;



// WEBPACK FOOTER //
// ./src/arteia-js/components/Icons/Icon.js